<template>
    <div class="z-30 w-full h-screen fixed top-0 left-0 flex items-center justify-center" :class="variant && variant === 'black' ? 'bg-black' : 'bg-white'">
        <span class="loader"></span>
    </div>
</template>

<script>
export default {
    name: 'AtomFullPageLoader',
    props: {
        variant: {
            type: String,
        }
    }
}
</script>

<style lang="scss" scoped>
.loader {
    width: 48px;
    height: 48px;
    display: inline-block;
    position: relative;
}
.loader::after,
.loader::before {
    content: '';
    box-sizing: border-box;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #DEDEDE;
    position: absolute;
    left: 0;
    top: 0;
    animation: animloader 2s linear infinite;
}

@keyframes animloader {
    0% {
        transform: scale(0);
        opacity: 1;
    }
    100% {
        transform: scale(1);
        opacity: 0;
    }
}

</style>
